import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApplicationService } from '@core/services/application.service';
import { Config } from '@core/models/config';
import { Residence } from '@core/models/residence';
import { ResidenceService } from '@core/services/residence.service';
import { ConfigService } from '@core/services/config.service';

@Component({
	selector: 'app-settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.scss'],
	host: { 'class': 'd-block settings p-4' }
})

export class SettingsComponent implements OnInit {

	residenceService: ResidenceService;
	residences: Residence[];
	residence: Residence;
	network: string;
	displayTimestamp: boolean;

	constructor(residenceService: ResidenceService,
		private router: Router,
		private applicationService: ApplicationService,
		private configService: ConfigService) {

		this.applicationService.updateSettings('Instellingen');

		let config = this.configService.getConfig();
		this.residence = config.residence;
		this.network = config.network;
		this.displayTimestamp = config.displayTimestamp ? config.displayTimestamp : true;

		this.residenceService = residenceService;
		this.residences = [];
		this.getResidenceList(0, 50);
	}

	ngOnInit() {
	}

	public saveSettings() {

		let config = new Config();
		config.network = this.network;
		config.displayTimestamp = this.displayTimestamp;
		config.residence = this.residences.find(r => r.code === this.residence.code);

		this.configService.saveConfig(config);
		this.router.navigateByUrl('/');
	}

	private getResidenceList(offset: number, limit: number) {

		this.residenceService.getResidenceResponse(offset, limit).then(
			(ress) => {
				offset += limit;
				ress.items.forEach((residence) => this.residences.push(residence));
				if (ress.items.length == limit) {
					this.getResidenceList(offset, limit);
				}
			}
		);
	}
}
